import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface HotelAndMarketDropdownsTriggersAccountTriggerSignature {
  Args: {};
}

const HotelAndMarketDropdownsTriggersAccountTrigger = <template>
  <div class="account-trigger ic-product-tour-settings-account">
    <PrismIcon @color="inherit" @name="circle-user" @size="large" />
  </div>
</template> satisfies TOC<HotelAndMarketDropdownsTriggersAccountTriggerSignature>;

export default HotelAndMarketDropdownsTriggersAccountTrigger;
